
const CollapsePlus = () => {
	return (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10 0.833008V19.1663" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M19.1668 10H0.833496" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
	</svg>);
};

export default CollapsePlus;
